module.exports = __webpack_public_path__ + "img/logo-old-black.53afd890.png";